import { dataCoin } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCoin = /*#__PURE__*/createIcon(dataCoin)
export default IconCoin
